import { render } from "./CoBrandGilt.vue?vue&type=template&id=4f0605b5&scoped=true"
import script from "./CoBrandGilt.vue?vue&type=script&lang=js"
export * from "./CoBrandGilt.vue?vue&type=script&lang=js"

import "./CoBrandGilt.vue?vue&type=style&index=0&id=4f0605b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0605b5"]])

export default __exports__